export default "__VITE_ASSET__BjCdmhYG__"